"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowApi = exports.WorkflowApiFactory = exports.WorkflowApiFp = exports.WorkflowApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * WorkflowApi - axios parameter creator
 * @export
 */
const WorkflowApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * v1 Get All Workflow Instances. Fetches all the workflow instances. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get All Workflow Instances
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit number of returned polls.
         * @param {number} [offset] The (zero-based) offset of the first item returned in the collection. In a zero-based offset 0 is a correct value.
         * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWorkflowInstances: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, limit, offset, workflowStates, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getAllWorkflowInstances', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getAllWorkflowInstances', 'recipientId', recipientId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (workflowStates) {
                localVarQueryParameter['workflow_states'] = workflowStates;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows`,
                sdkMethod: 'getAllWorkflowInstances',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Workflow Instances. Fetches all the workflow instances for the given definition id. This will rarely be needed by the client. This is built for admin purposes. The v1GetWorkflowsForRecipient should include the defn and the latest instance for clients. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Workflow Instances
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowInstances: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('getWorkflowInstances', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getWorkflowInstances', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('getWorkflowInstances', 'workflowDefnId', workflowDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}`,
                sdkMethod: 'getWorkflowInstances',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copies all the data - workflows, steps, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten. To identify if a particular data item is copied, the circle service recipient data has to be looked at.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowRecipientCopyRequest} [workflowRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, userId, workflowRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient', 'recipientId', recipientId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/copy`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/copy`,
                sdkMethod: 'v1CopyDataToNewRecipient',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workflowRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Delete Recipient Data. Soft deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Recipient Data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteRecipientData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, acceptLanguage, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteRecipientData', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteRecipientData', 'recipientId', recipientId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}`,
                sdkMethod: 'v1DeleteRecipientData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Delete Step Instance. Soft deletes the step given by the specific instance id. The step_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Step Instance
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} stepInstanceId Step Instance ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteStepInstance: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, stepInstanceId, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteStepInstance', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteStepInstance', 'recipientId', recipientId);
            // verify required parameter 'stepInstanceId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteStepInstance', 'stepInstanceId', stepInstanceId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/instances/steps/{step_instance_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'step_instance_id'}}`, encodeURIComponent(String(stepInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/instances/steps/{step_instance_id}`,
                sdkMethod: 'v1DeleteStepInstance',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Delete User Data. Soft deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
         * @summary v1 Delete User Data
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteUserData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteUserData', 'userId', userId);
            const localVarPath = `/v1/workflows/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/users/{user_id}`,
                sdkMethod: 'v1DeleteUserData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Delete Workflow Instance. Soft deletes all the workflow and related steps given by the specific instance id. The workflow_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Workflow Instance
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowInstanceId Workflow Instance ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteWorkflowInstance: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowInstanceId, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteWorkflowInstance', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteWorkflowInstance', 'recipientId', recipientId);
            // verify required parameter 'workflowInstanceId' is not null or undefined
            (0, common_1.assertParamExists)('v1DeleteWorkflowInstance', 'workflowInstanceId', workflowInstanceId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/instances/workflows/{workflow_instance_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_instance_id'}}`, encodeURIComponent(String(workflowInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/instances/workflows/{workflow_instance_id}`,
                sdkMethod: 'v1DeleteWorkflowInstance',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Expunge Recipient Data. Hard deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | e |
         * @summary v1 Expunge Recipient Data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ExpungeRecipientData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1ExpungeRecipientData', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1ExpungeRecipientData', 'recipientId', recipientId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/expunge`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/expunge`,
                sdkMethod: 'v1ExpungeRecipientData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Expunge User Data. Hard deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
         * @summary v1 Expunge User Data
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ExpungeUserData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1ExpungeUserData', 'userId', userId);
            const localVarPath = `/v1/workflows/users/{user_id}/expunge`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/users/{user_id}/expunge`,
                sdkMethod: 'v1ExpungeUserData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Next Step returns the next step to execute by the client. The workflow should not in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching next step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Next Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetNextStep: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, acceptLanguage, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1GetNextStep', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetNextStep', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetNextStep', 'workflowDefnId', workflowDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/next`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/next`,
                sdkMethod: 'v1GetNextStep',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Previous Step returns the previous step to execute by the client. Note this step will remove current step and returns previous step. The workflow should not be in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching prev step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.  - On attempt to get previous step, for instance with completed, abandoned API will return 400 status code. - On attempt to get previous step, for instance with created, or current step is first step API will return 404 status code.  |Feature|Dataclass|Permission| |-------|---------|----------| | workflow | workflow | r |
         * @summary v1 Get Previous Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPreviousStep: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, acceptLanguage, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPreviousStep', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPreviousStep', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPreviousStep', 'workflowDefnId', workflowDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/previous`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/previous`,
                sdkMethod: 'v1GetPreviousStep',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get User Settings. Gets the settings for the user in context of a circle. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get User Settings
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetUserSettings: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1GetUserSettings', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetUserSettings', 'recipientId', recipientId);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetUserSettings', 'userId', userId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/users/{user_id}/settings`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/users/{user_id}/settings`,
                sdkMethod: 'v1GetUserSettings',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Workflows for recipient. Retrieves all the workflows by either given workflow_defn_id or workflow_type but not both. The response includes the definition and if there is any instance for it in the database for the recipient, then the most recent instance. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Workflows for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {string} [workflowDefnId] Workflow Definition ID. One of workflow_defn_id or workflow_type is required.
         * @param {string} [workflowType] Workflow Type. One of workflow_defn_id or workflow_type is required.
         * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
         * @param {number} [limit] Limit at workflows level. Default - 10. (Not at step level)
         * @param {number} [offset] Offset at workflow level. Default - 0. (Not at step level)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetWorkflowsForRecipient: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, acceptLanguage, userId, workflowDefnId, workflowType, workflowStates, limit, offset, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1GetWorkflowsForRecipient', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetWorkflowsForRecipient', 'recipientId', recipientId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (workflowDefnId !== undefined) {
                localVarQueryParameter['workflow_defn_id'] = workflowDefnId;
            }
            if (workflowType !== undefined) {
                localVarQueryParameter['workflow_type'] = workflowType;
            }
            if (workflowStates) {
                localVarQueryParameter['workflow_states'] = workflowStates;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}`,
                sdkMethod: 'v1GetWorkflowsForRecipient',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Reset Step. Reset will remove all steps up to `step_defn_id`.  e.g. `[step_1, step_2, step_3, step_4, step_5]` -> `reset(step_2)` -> `[step_1, step_2]`.  Reset the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After reset, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Reset To Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} stepDefnId Step Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowResetToStepRequest} [workflowResetToStepRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResetToStep: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, stepDefnId, userId, workflowResetToStepRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1ResetToStep', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResetToStep', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResetToStep', 'workflowDefnId', workflowDefnId);
            // verify required parameter 'stepDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResetToStep', 'stepDefnId', stepDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/steps/{step_defn_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)))
                .replace(`{${'step_defn_id'}}`, encodeURIComponent(String(stepDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/steps/{step_defn_id}`,
                sdkMethod: 'v1ResetToStep',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workflowResetToStepRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Reset Workflow Resets an existing instance of a workflow in the database for the provided definition ID. This operation behaves like a restart, but the workflow instance is not recreated. Instead, the existing instance is returned with its state set to CREATED, and all associated steps are removed. Note: Workflows in the ABANDONED or COMPLETED state cannot be reset. To preserve history, workflows in such states should be transitioned to the TERMINATED state before resetting.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Reset Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResetWorkflow: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, acceptLanguage, userId, body, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1ResetWorkflow', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResetWorkflow', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1ResetWorkflow', 'workflowDefnId', workflowDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/reset`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/reset`,
                sdkMethod: 'v1ResetWorkflow',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Restart Workflow re-starts a workflow by creating or reset existing  instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed to created and steps would be removed. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Restart Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RestartWorkflow: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, acceptLanguage, userId, body, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1RestartWorkflow', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1RestartWorkflow', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1RestartWorkflow', 'workflowDefnId', workflowDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/restart`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/restart`,
                sdkMethod: 'v1RestartWorkflow',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Start Workflow starts a workflow by creating an instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed appropriately to continue. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Start Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1StartWorkflow: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, acceptLanguage, userId, body, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1StartWorkflow', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1StartWorkflow', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1StartWorkflow', 'workflowDefnId', workflowDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/start`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/start`,
                sdkMethod: 'v1StartWorkflow',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Update Step. Updates the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After update, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Update Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} stepDefnId Step Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowUpdateStepRequest} [workflowUpdateStepRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpdateStep: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, stepDefnId, userId, workflowUpdateStepRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1UpdateStep', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1UpdateStep', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1UpdateStep', 'workflowDefnId', workflowDefnId);
            // verify required parameter 'stepDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1UpdateStep', 'stepDefnId', stepDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/steps/{step_defn_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)))
                .replace(`{${'step_defn_id'}}`, encodeURIComponent(String(stepDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/steps/{step_defn_id}`,
                sdkMethod: 'v1UpdateStep',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workflowUpdateStepRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Update Workflow. Updates the workflow with information like the state. After update, the updated instance of the workflow is returned. A recent workflow instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Update Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {WorkflowUpdateWorkflowRequest} [workflowUpdateWorkflowRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpdateWorkflow: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, workflowDefnId, userId, acceptLanguage, workflowUpdateWorkflowRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1UpdateWorkflow', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1UpdateWorkflow', 'recipientId', recipientId);
            // verify required parameter 'workflowDefnId' is not null or undefined
            (0, common_1.assertParamExists)('v1UpdateWorkflow', 'workflowDefnId', workflowDefnId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'workflow_defn_id'}}`, encodeURIComponent(String(workflowDefnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}`,
                sdkMethod: 'v1UpdateWorkflow',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workflowUpdateWorkflowRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Upsert User Settings. Upserts the settings for the user in context of a circle. Only workflow level settings are supported and defnId in the body must be one of the known workflows. Two types of settings are supported: * fav - User favorited workflows, allowed values - true, false * rrule - The reminder schedule as defined in RFC 5545, allowed values - https://icalendar.org/iCalendar-RFC-5545/3-8-5-3-recurrence-rule.html The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Upsert User Settings
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID
         * @param {WorkflowUpsertSettingReq} [workflowUpsertSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpsertUserSetting: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, userId, workflowUpsertSettingReq, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1UpsertUserSetting', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1UpsertUserSetting', 'recipientId', recipientId);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UpsertUserSetting', 'userId', userId);
            const localVarPath = `/v1/workflows/recipients/{recipient_id}/users/{user_id}/settings`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/recipients/{recipient_id}/users/{user_id}/settings`,
                sdkMethod: 'v1UpsertUserSetting',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(workflowUpsertSettingReq, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WorkflowApiAxiosParamCreator = WorkflowApiAxiosParamCreator;
/**
 * WorkflowApi - functional programming interface
 * @export
 */
const WorkflowApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WorkflowApiAxiosParamCreator)(configuration);
    return {
        /**
         * v1 Get All Workflow Instances. Fetches all the workflow instances. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get All Workflow Instances
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit number of returned polls.
         * @param {number} [offset] The (zero-based) offset of the first item returned in the collection. In a zero-based offset 0 is a correct value.
         * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWorkflowInstances(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllWorkflowInstances(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Get Workflow Instances. Fetches all the workflow instances for the given definition id. This will rarely be needed by the client. This is built for admin purposes. The v1GetWorkflowsForRecipient should include the defn and the latest instance for clients. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Workflow Instances
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowInstances(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkflowInstances(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Copies all the data - workflows, steps, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten. To identify if a particular data item is copied, the circle service recipient data has to be looked at.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowRecipientCopyRequest} [workflowRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1CopyDataToNewRecipient(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Delete Recipient Data. Soft deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Recipient Data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteRecipientData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DeleteRecipientData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Delete Step Instance. Soft deletes the step given by the specific instance id. The step_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Step Instance
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} stepInstanceId Step Instance ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteStepInstance(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DeleteStepInstance(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Delete User Data. Soft deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
         * @summary v1 Delete User Data
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteUserData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DeleteUserData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Delete Workflow Instance. Soft deletes all the workflow and related steps given by the specific instance id. The workflow_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Workflow Instance
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowInstanceId Workflow Instance ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteWorkflowInstance(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1DeleteWorkflowInstance(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Expunge Recipient Data. Hard deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | e |
         * @summary v1 Expunge Recipient Data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ExpungeRecipientData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ExpungeRecipientData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Expunge User Data. Hard deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
         * @summary v1 Expunge User Data
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ExpungeUserData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ExpungeUserData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Get Next Step returns the next step to execute by the client. The workflow should not in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching next step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Next Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetNextStep(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetNextStep(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Get Previous Step returns the previous step to execute by the client. Note this step will remove current step and returns previous step. The workflow should not be in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching prev step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.  - On attempt to get previous step, for instance with completed, abandoned API will return 400 status code. - On attempt to get previous step, for instance with created, or current step is first step API will return 404 status code.  |Feature|Dataclass|Permission| |-------|---------|----------| | workflow | workflow | r |
         * @summary v1 Get Previous Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPreviousStep(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPreviousStep(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Get User Settings. Gets the settings for the user in context of a circle. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get User Settings
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetUserSettings(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetUserSettings(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Get Workflows for recipient. Retrieves all the workflows by either given workflow_defn_id or workflow_type but not both. The response includes the definition and if there is any instance for it in the database for the recipient, then the most recent instance. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Workflows for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {string} [workflowDefnId] Workflow Definition ID. One of workflow_defn_id or workflow_type is required.
         * @param {string} [workflowType] Workflow Type. One of workflow_defn_id or workflow_type is required.
         * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
         * @param {number} [limit] Limit at workflows level. Default - 10. (Not at step level)
         * @param {number} [offset] Offset at workflow level. Default - 0. (Not at step level)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetWorkflowsForRecipient(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetWorkflowsForRecipient(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Reset Step. Reset will remove all steps up to `step_defn_id`.  e.g. `[step_1, step_2, step_3, step_4, step_5]` -> `reset(step_2)` -> `[step_1, step_2]`.  Reset the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After reset, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Reset To Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} stepDefnId Step Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowResetToStepRequest} [workflowResetToStepRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResetToStep(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResetToStep(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Reset Workflow Resets an existing instance of a workflow in the database for the provided definition ID. This operation behaves like a restart, but the workflow instance is not recreated. Instead, the existing instance is returned with its state set to CREATED, and all associated steps are removed. Note: Workflows in the ABANDONED or COMPLETED state cannot be reset. To preserve history, workflows in such states should be transitioned to the TERMINATED state before resetting.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Reset Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResetWorkflow(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ResetWorkflow(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Restart Workflow re-starts a workflow by creating or reset existing  instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed to created and steps would be removed. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Restart Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RestartWorkflow(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RestartWorkflow(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Start Workflow starts a workflow by creating an instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed appropriately to continue. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Start Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1StartWorkflow(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1StartWorkflow(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Update Step. Updates the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After update, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Update Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} stepDefnId Step Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowUpdateStepRequest} [workflowUpdateStepRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpdateStep(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UpdateStep(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Update Workflow. Updates the workflow with information like the state. After update, the updated instance of the workflow is returned. A recent workflow instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Update Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {WorkflowUpdateWorkflowRequest} [workflowUpdateWorkflowRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpdateWorkflow(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UpdateWorkflow(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * v1 Upsert User Settings. Upserts the settings for the user in context of a circle. Only workflow level settings are supported and defnId in the body must be one of the known workflows. Two types of settings are supported: * fav - User favorited workflows, allowed values - true, false * rrule - The reminder schedule as defined in RFC 5545, allowed values - https://icalendar.org/iCalendar-RFC-5545/3-8-5-3-recurrence-rule.html The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Upsert User Settings
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID
         * @param {WorkflowUpsertSettingReq} [workflowUpsertSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpsertUserSetting(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UpsertUserSetting(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.WorkflowApiFp = WorkflowApiFp;
/**
 * WorkflowApi - factory interface
 * @export
 */
const WorkflowApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WorkflowApiFp)(configuration);
    return {
        /**
         * v1 Get All Workflow Instances. Fetches all the workflow instances. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get All Workflow Instances
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit number of returned polls.
         * @param {number} [offset] The (zero-based) offset of the first item returned in the collection. In a zero-based offset 0 is a correct value.
         * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWorkflowInstances(params, options) {
            return localVarFp
                .getAllWorkflowInstances(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Workflow Instances. Fetches all the workflow instances for the given definition id. This will rarely be needed by the client. This is built for admin purposes. The v1GetWorkflowsForRecipient should include the defn and the latest instance for clients. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Workflow Instances
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkflowInstances(params, options) {
            return localVarFp
                .getWorkflowInstances(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies all the data - workflows, steps, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten. To identify if a particular data item is copied, the circle service recipient data has to be looked at.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowRecipientCopyRequest} [workflowRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient(params, options) {
            return localVarFp
                .v1CopyDataToNewRecipient(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Delete Recipient Data. Soft deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Recipient Data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteRecipientData(params, options) {
            return localVarFp
                .v1DeleteRecipientData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Delete Step Instance. Soft deletes the step given by the specific instance id. The step_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Step Instance
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} stepInstanceId Step Instance ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteStepInstance(params, options) {
            return localVarFp
                .v1DeleteStepInstance(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Delete User Data. Soft deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
         * @summary v1 Delete User Data
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteUserData(params, options) {
            return localVarFp
                .v1DeleteUserData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Delete Workflow Instance. Soft deletes all the workflow and related steps given by the specific instance id. The workflow_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
         * @summary v1 Delete Workflow Instance
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowInstanceId Workflow Instance ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1DeleteWorkflowInstance(params, options) {
            return localVarFp
                .v1DeleteWorkflowInstance(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Expunge Recipient Data. Hard deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | e |
         * @summary v1 Expunge Recipient Data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ExpungeRecipientData(params, options) {
            return localVarFp
                .v1ExpungeRecipientData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Expunge User Data. Hard deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
         * @summary v1 Expunge User Data
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ExpungeUserData(params, options) {
            return localVarFp
                .v1ExpungeUserData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Next Step returns the next step to execute by the client. The workflow should not in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching next step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Next Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetNextStep(params, options) {
            return localVarFp
                .v1GetNextStep(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Previous Step returns the previous step to execute by the client. Note this step will remove current step and returns previous step. The workflow should not be in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching prev step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.  - On attempt to get previous step, for instance with completed, abandoned API will return 400 status code. - On attempt to get previous step, for instance with created, or current step is first step API will return 404 status code.  |Feature|Dataclass|Permission| |-------|---------|----------| | workflow | workflow | r |
         * @summary v1 Get Previous Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPreviousStep(params, options) {
            return localVarFp
                .v1GetPreviousStep(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get User Settings. Gets the settings for the user in context of a circle. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get User Settings
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetUserSettings(params, options) {
            return localVarFp
                .v1GetUserSettings(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Workflows for recipient. Retrieves all the workflows by either given workflow_defn_id or workflow_type but not both. The response includes the definition and if there is any instance for it in the database for the recipient, then the most recent instance. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
         * @summary v1 Get Workflows for recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {string} [workflowDefnId] Workflow Definition ID. One of workflow_defn_id or workflow_type is required.
         * @param {string} [workflowType] Workflow Type. One of workflow_defn_id or workflow_type is required.
         * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
         * @param {number} [limit] Limit at workflows level. Default - 10. (Not at step level)
         * @param {number} [offset] Offset at workflow level. Default - 0. (Not at step level)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetWorkflowsForRecipient(params, options) {
            return localVarFp
                .v1GetWorkflowsForRecipient(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Reset Step. Reset will remove all steps up to `step_defn_id`.  e.g. `[step_1, step_2, step_3, step_4, step_5]` -> `reset(step_2)` -> `[step_1, step_2]`.  Reset the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After reset, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Reset To Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} stepDefnId Step Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowResetToStepRequest} [workflowResetToStepRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResetToStep(params, options) {
            return localVarFp
                .v1ResetToStep(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Reset Workflow Resets an existing instance of a workflow in the database for the provided definition ID. This operation behaves like a restart, but the workflow instance is not recreated. Instead, the existing instance is returned with its state set to CREATED, and all associated steps are removed. Note: Workflows in the ABANDONED or COMPLETED state cannot be reset. To preserve history, workflows in such states should be transitioned to the TERMINATED state before resetting.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Reset Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ResetWorkflow(params, options) {
            return localVarFp
                .v1ResetWorkflow(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Restart Workflow re-starts a workflow by creating or reset existing  instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed to created and steps would be removed. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Restart Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RestartWorkflow(params, options) {
            return localVarFp
                .v1RestartWorkflow(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Start Workflow starts a workflow by creating an instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed appropriately to continue. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Start Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1StartWorkflow(params, options) {
            return localVarFp
                .v1StartWorkflow(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Update Step. Updates the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After update, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Update Step
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} stepDefnId Step Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {WorkflowUpdateStepRequest} [workflowUpdateStepRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpdateStep(params, options) {
            return localVarFp
                .v1UpdateStep(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Update Workflow. Updates the workflow with information like the state. After update, the updated instance of the workflow is returned. A recent workflow instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
         * @summary v1 Update Workflow
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} workflowDefnId Workflow Definition ID
         * @param {string} [userId] Optional user ID passed as a query parameter
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {WorkflowUpdateWorkflowRequest} [workflowUpdateWorkflowRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpdateWorkflow(params, options) {
            return localVarFp
                .v1UpdateWorkflow(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Upsert User Settings. Upserts the settings for the user in context of a circle. Only workflow level settings are supported and defnId in the body must be one of the known workflows. Two types of settings are supported: * fav - User favorited workflows, allowed values - true, false * rrule - The reminder schedule as defined in RFC 5545, allowed values - https://icalendar.org/iCalendar-RFC-5545/3-8-5-3-recurrence-rule.html The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
         * @summary v1 Upsert User Settings
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID
         * @param {WorkflowUpsertSettingReq} [workflowUpsertSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UpsertUserSetting(params, options) {
            return localVarFp
                .v1UpsertUserSetting(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.WorkflowApiFactory = WorkflowApiFactory;
/**
 * WorkflowApi - object-oriented interface
 * @export
 * @class WorkflowApi
 * @extends {BaseAPI}
 */
class WorkflowApi extends base_1.BaseAPI {
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows`
     * v1 Get All Workflow Instances. Fetches all the workflow instances. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
     * @summary v1 Get All Workflow Instances
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} [limit] Limit number of returned polls.
     * @param {number} [offset] The (zero-based) offset of the first item returned in the collection. In a zero-based offset 0 is a correct value.
     * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    getAllWorkflowInstances(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .getAllWorkflowInstances(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}`
     * v1 Get Workflow Instances. Fetches all the workflow instances for the given definition id. This will rarely be needed by the client. This is built for admin purposes. The v1GetWorkflowsForRecipient should include the defn and the latest instance for clients. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
     * @summary v1 Get Workflow Instances
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    getWorkflowInstances(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .getWorkflowInstances(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/copy`
     * Copies all the data - workflows, steps, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten. To identify if a particular data item is copied, the circle service recipient data has to be looked at.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {WorkflowRecipientCopyRequest} [workflowRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1CopyDataToNewRecipient(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1CopyDataToNewRecipient(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}`
     * v1 Delete Recipient Data. Soft deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
     * @summary v1 Delete Recipient Data
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1DeleteRecipientData(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1DeleteRecipientData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/instances/steps/{step_instance_id}`
     * v1 Delete Step Instance. Soft deletes the step given by the specific instance id. The step_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
     * @summary v1 Delete Step Instance
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} stepInstanceId Step Instance ID
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1DeleteStepInstance(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1DeleteStepInstance(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/users/{user_id}`
     * v1 Delete User Data. Soft deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
     * @summary v1 Delete User Data
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1DeleteUserData(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1DeleteUserData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/instances/workflows/{workflow_instance_id}`
     * v1 Delete Workflow Instance. Soft deletes all the workflow and related steps given by the specific instance id. The workflow_instance_id should belong to the recipient_id. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | d |
     * @summary v1 Delete Workflow Instance
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowInstanceId Workflow Instance ID
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1DeleteWorkflowInstance(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1DeleteWorkflowInstance(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/expunge`
     * v1 Expunge Recipient Data. Hard deletes all the recipient data. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | e |
     * @summary v1 Expunge Recipient Data
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1ExpungeRecipientData(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1ExpungeRecipientData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/users/{user_id}/expunge`
     * v1 Expunge User Data. Hard deletes all the user specific data.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | - | - | - |
     * @summary v1 Expunge User Data
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1ExpungeUserData(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1ExpungeUserData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/next`
     * v1 Get Next Step returns the next step to execute by the client. The workflow should not in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching next step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
     * @summary v1 Get Next Step
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1GetNextStep(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1GetNextStep(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/previous`
     * v1 Get Previous Step returns the previous step to execute by the client. Note this step will remove current step and returns previous step. The workflow should not be in the abandoned state. If it is, then workflow needs to be started using the v1StartWorkflow operation. Though this is a get operation, note that fetching prev step might update the database state for the workflow and the related step. This endpoint is not a truly RESTY. The circle token must have permission for the workflow and the type of the workflow.  - On attempt to get previous step, for instance with completed, abandoned API will return 400 status code. - On attempt to get previous step, for instance with created, or current step is first step API will return 404 status code.  |Feature|Dataclass|Permission| |-------|---------|----------| | workflow | workflow | r |
     * @summary v1 Get Previous Step
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1GetPreviousStep(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1GetPreviousStep(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/users/{user_id}/settings`
     * v1 Get User Settings. Gets the settings for the user in context of a circle. The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
     * @summary v1 Get User Settings
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1GetUserSettings(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1GetUserSettings(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}`
     * v1 Get Workflows for recipient. Retrieves all the workflows by either given workflow_defn_id or workflow_type but not both. The response includes the definition and if there is any instance for it in the database for the recipient, then the most recent instance. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | r |
     * @summary v1 Get Workflows for recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {string} [workflowDefnId] Workflow Definition ID. One of workflow_defn_id or workflow_type is required.
     * @param {string} [workflowType] Workflow Type. One of workflow_defn_id or workflow_type is required.
     * @param {Array<WorkflowWorkflowState>} [workflowStates] Workflow States. Format ?workflow_states&#x3D;wrkf_created&amp;workflow_states&#x3D;wrkf_completed&amp;..
     * @param {number} [limit] Limit at workflows level. Default - 10. (Not at step level)
     * @param {number} [offset] Offset at workflow level. Default - 0. (Not at step level)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1GetWorkflowsForRecipient(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1GetWorkflowsForRecipient(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/steps/{step_defn_id}`
     * v1 Reset Step. Reset will remove all steps up to `step_defn_id`.  e.g. `[step_1, step_2, step_3, step_4, step_5]` -> `reset(step_2)` -> `[step_1, step_2]`.  Reset the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After reset, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
     * @summary v1 Reset To Step
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} stepDefnId Step Definition ID
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {WorkflowResetToStepRequest} [workflowResetToStepRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1ResetToStep(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1ResetToStep(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/reset`
     * v1 Reset Workflow Resets an existing instance of a workflow in the database for the provided definition ID. This operation behaves like a restart, but the workflow instance is not recreated. Instead, the existing instance is returned with its state set to CREATED, and all associated steps are removed. Note: Workflows in the ABANDONED or COMPLETED state cannot be reset. To preserve history, workflows in such states should be transitioned to the TERMINATED state before resetting.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
     * @summary v1 Reset Workflow
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1ResetWorkflow(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1ResetWorkflow(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/restart`
     * v1 Restart Workflow re-starts a workflow by creating or reset existing  instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed to created and steps would be removed. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
     * @summary v1 Restart Workflow
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1RestartWorkflow(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1RestartWorkflow(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/start`
     * v1 Start Workflow starts a workflow by creating an instance of the workflow in the database for the provided defn id. If the most recent workflow has been completed recently, then a new instance of the workflow is created. If there is a workflow instance that is not completed but in some other state, then the same instance is returned with its state changed appropriately to continue. The circle token must have permission for the workflow and the type of the workflow.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
     * @summary v1 Start Workflow
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1StartWorkflow(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1StartWorkflow(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}/steps/{step_defn_id}`
     * v1 Update Step. Updates the step with information like the state, the related service ids and in case of steps like confirmation dialog, the selected button id. After update, the get next step algorithm is run to return the step to execute by the client. An workflow instance and the related step instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
     * @summary v1 Update Step
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} stepDefnId Step Definition ID
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {WorkflowUpdateStepRequest} [workflowUpdateStepRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1UpdateStep(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1UpdateStep(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/workflows/{workflow_defn_id}`
     * v1 Update Workflow. Updates the workflow with information like the state. After update, the updated instance of the workflow is returned. A recent workflow instance should exist in the DB for the update to succeed. Workflow instance is created by calling the v1StartWorkflow operation. The circle token must have permission for the workflow and the type of the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | u |
     * @summary v1 Update Workflow
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} workflowDefnId Workflow Definition ID
     * @param {string} [userId] Optional user ID passed as a query parameter
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {WorkflowUpdateWorkflowRequest} [workflowUpdateWorkflowRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1UpdateWorkflow(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1UpdateWorkflow(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/recipients/{recipient_id}/users/{user_id}/settings`
     * v1 Upsert User Settings. Upserts the settings for the user in context of a circle. Only workflow level settings are supported and defnId in the body must be one of the known workflows. Two types of settings are supported: * fav - User favorited workflows, allowed values - true, false * rrule - The reminder schedule as defined in RFC 5545, allowed values - https://icalendar.org/iCalendar-RFC-5545/3-8-5-3-recurrence-rule.html The circle token must have permission for the workflow.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | workflow | workflow | c |
     * @summary v1 Upsert User Settings
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} userId User ID
     * @param {WorkflowUpsertSettingReq} [workflowUpsertSettingReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowApi
     */
    v1UpsertUserSetting(params, options) {
        return (0, exports.WorkflowApiFp)(this.configuration)
            .v1UpsertUserSetting(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.WorkflowApi = WorkflowApi;
//# sourceMappingURL=workflow-api.js.map